import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";
import { NodelMasterData } from "types/models/nodelMaster/NodelMasterApp";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: keyof NodelMasterData;
  onSort: (property: keyof NodelMasterData) => void;
}

const TableHeading: React.FC<TableHeadingProps> = ({
  order,
  orderBy,
  onSort,
}) => {
  const createSortHandler = (property: keyof NodelMasterData) => () => {
    onSort(property);
  };

  const uniformWidth = { width: '150px' };

  return (
    <TableHeader>
      <TableCell align="left" sx={uniformWidth}>
        <TableSortLabel
          active={orderBy === "createdAt"}
          direction={orderBy === "createdAt" ? order : "asc"}
          onClick={createSortHandler("createdAt")}
        >
          Date
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" sx={uniformWidth}>Customer ID</TableCell>
      <TableCell align="left" sx={uniformWidth}>Ticket ID</TableCell>
      <TableCell align="left" sx={uniformWidth}>Remarks</TableCell>
      <TableCell align="left" sx={uniformWidth}>Source</TableCell>
      <TableCell align="left" sx={uniformWidth}>Reference</TableCell>
      <TableCell align="left" sx={uniformWidth}>Name</TableCell>
      <TableCell align="left" sx={uniformWidth}>Mobile</TableCell>
      <TableCell align="left" sx={uniformWidth}>Email</TableCell>
    </TableHeader>
  );
};

export default TableHeading;
